/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { SavedTableView } from 'types/entities/SavedTableView'

export const normalizeSavedViewName = (name: string | null | undefined): string =>
    (name ?? '').trim().toLowerCase()

/** Find an existing view by name (case-insensitive, trimmed) within the provided list. */
export const findSavedViewByName = (
    views: SavedTableView[],
    name: string | null | undefined
): SavedTableView | undefined => {
    const normalized = normalizeSavedViewName(name)
    if (!normalized) return undefined
    return views.find((view) => normalizeSavedViewName(view.name) === normalized)
}
